// =================================================================
// Design System Theme Constants
// =================================================================
// This file mirrors the SCSS variables in variables.scss and
// designSystemClasses.scss to make them available for inline styles
// in React components. Keep this file in sync when updating SCSS.

// -----------------------------------------------------------------
// Brand Colors
// -----------------------------------------------------------------
export const colors = {
  // Cotribute Brand Colors
  brandPrimary: "#52c1b2",
  brandGreen: "#8dc756",
  brandOrange: "#f99e1b",
  brandCoral: "#ee6e7d",
  brandGray1: "#edf2f2",
  brandGray2: "#bac9c7",
  brandGray3: "#262f2c",

  // Standard Grays
  gray: "#d5d5d5",
  gray7: "#595959",
  gray8: "#343d3a",
  gray9: "#262626",

  // Other Colors
  darkBlue: "#004e6e",
  white: "#ffffff",
  bodyBg: "#f6f6f6",

  // Ant Design semantic colors (for consistency)
  textPrimary: "rgba(0, 0, 0, 0.88)",
  textSecondary: "rgba(0, 0, 0, 0.45)",
  textTertiary: "rgba(0, 0, 0, 0.25)",
  textDisabled: "rgba(0, 0, 0, 0.25)",
} as const;

// -----------------------------------------------------------------
// Spacing Scale (matches $spacing-* variables)
// -----------------------------------------------------------------
export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 48,
  9: 64,
  10: 80,
  11: 100,
} as const;

// -----------------------------------------------------------------
// Typography (matches .f-* classes)
// -----------------------------------------------------------------
export const fontSize = {
  1: 10,
  2: 12,
  3: 14,
  4: 16,
  5: 20,
  6: 24,
  7: 30,
  8: 38,
  9: 50,
  10: 60,
  11: 70,
  12: 80,
  13: 90,
  14: 100,
} as const;

// -----------------------------------------------------------------
// Other Design Tokens
// -----------------------------------------------------------------
export const fontWeightBold = 600;
export const radius = 8;
export const transition = "0.25s";

// -----------------------------------------------------------------
// Utility Functions
// -----------------------------------------------------------------

/**
 * Get spacing value by key
 * @example getSpacing(4) // returns 16
 */
export const getSpacing = (key: keyof typeof spacing): number => spacing[key];

/**
 * Get font size by key
 * @example getFontSize(3) // returns 14
 */
export const getFontSize = (key: keyof typeof fontSize): number =>
  fontSize[key];
